import { type FC } from 'react';
import { createNabTransactPayment, type NabTransactOptions } from '@/api/registration/payment';
import { useTenantApi } from '@/account/hook/useTenantApi';
import { useRegisterGroupSteps } from '@/registration/hook/useRegisterGroupSteps';
import CardNabForm from '@/registration/component/CardNabForm';

export interface PayByNabTransactProps {
  setErrors: React.Dispatch<React.SetStateAction<string[]>>
  options: NabTransactOptions
  isValid: boolean
}

interface FormData {
  cardNumber: string
  expiry: string
  cvv: string
}

const encodeData = (data: string): string => {
  return btoa(data);
};

const PayByNabTransact: FC<PayByNabTransactProps> = ({ setErrors, options }) => {
  const { toPaymentProcessingStep } = useRegisterGroupSteps();
  const { createTenantApiRequest } = useTenantApi();

  const handleSubmit = async (values: FormData) => {
    try {
      const cardNumber = values.cardNumber.split(' ').join('');
      const [expiryMonth, expiryYear] = values.expiry.split('/');
      const response = await createNabTransactPayment(createTenantApiRequest)({
        orderId: options.order.id,
        ccNumber: encodeData(cardNumber),
        ccMonth: encodeData(expiryMonth),
        ccYear: encodeData(expiryYear),
        ccCvv: encodeData(values.cvv.toString())
      });

      if (!response.errors) {
        const additionalParams = { orderHash: options.order.secureHash };
        toPaymentProcessingStep(additionalParams);
      } else {
        setErrors([response.errors?.[0] ?? 'Payment failed']);
      }
    } catch (error) {
      setErrors(['An error occurred while processing the payment']);
    }
  };

  return (
    <CardNabForm handleSubmit={handleSubmit} />
  );
};

export default PayByNabTransact;
